/* unplugin-vue-components disabled */import { render } from "./StyleTextarea.vue?vue&type=template&id=6964777a"
import script from "./StyleTextarea.vue?vue&type=script&lang=js"
export * from "./StyleTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__